<template>
  <div class="highlighter-wrapper relative d-flex flex-grow-1 flex-wrap">
    <document-viewer
      v-if="!documentParsedDetails.isLoading"
      :document="document"
      :rotation="rotation"
      :overlays="documentParsedDetailBoundingBoxes"
      :show-page-check-signals="false"
      @rotate="$emit('rotate')"
    />
    <div v-else class="d-flex w-100 align-items-center justify-content-center">
      <i-spinner></i-spinner>
    </div>
  </div>
</template>

<script>
import DocumentViewer from './DocumentViewer';
import { iSpinner } from '@inscribe/signal';

export default {
  components: {
    'document-viewer': DocumentViewer,
    iSpinner,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
    rotation: {
      type: Number,
      required: true,
    },
  },
  computed: {
    documentParsedDetails() {
      return this.$store.state.documentParsedDetailsHighlighter;
    },
    documentParsedDetailBoundingBoxes() {
      if (this.documentParsedDetails.isLoading) {
        return [];
      }

      return this.documentParsedDetails.documents[this.document.id];
    },
  },
  created() {
    this.getParsedDetailsBoundingBoxes();
  },
  methods: {
    getParsedDetailsBoundingBoxes() {
      this.$store.commit('setParsedDetailsHighlighterLoading', true);
      this.$store
        .dispatch('getParsedDetailsHighlighterBoundingBoxes', {
          customerId: this.document.customer_id,
          documentId: this.document.id,
        })
        .then(() => {
          this.$store.commit('setParsedDetailsHighlighterLoading', false);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.highlighter-wrapper {
  max-height: 100%;
  overflow: auto;
}
</style>
